export function libelleDaeAffiche(livraison, reception) {
    if (livraison !== null && reception !== null) {
        if (livraison === reception) {
            return {
                texte: `LIV/REC : ${livraison}`,
                infobulle: `Livraison et réception : ${livraison}`,
            };
        }
        return {
            texte: `LIV : ${livraison} · REC : ${reception}`,
            infobulle: `Livraison : ${livraison} — Réception : ${reception}`,
        };
    }
    if (livraison !== null) {
        return { texte: `LIV : ${livraison}`, infobulle: `Livraison : ${livraison}` };
    }
    if (reception !== null) {
        return { texte: `REC : ${reception}`, infobulle: `Réception : ${reception}` };
    }
    return { texte: null, infobulle: null };
}
//# sourceMappingURL=libelle-dae.js.map